// Scope of the unread ("all-items") view: every subscribed feed, or — in the folder unread
// view (/a/new/<folder>) — only the feeds filed in that folder. Used to decide whether new
// unread posts exist for the current view; unread posts outside the folder don't count.

/** Feed ids whose unread posts belong to the view; a missing folder yields none. */
export const unreadScopeFeedIds = (feedIds: string[], folders: Record<string, string[]>, folder?: string): string[] =>
  folder == undefined ? feedIds : folders[folder] ?? [];

/** True when any feed in the view's scope still has unread posts. */
export const hasUnreadInScope = (feedIds: string[], folders: Record<string, string[]>, unreadCount: (id: string) => number, folder?: string) =>
  unreadScopeFeedIds(feedIds, folders, folder).some(id => unreadCount(id) > 0);
